/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { useState, useEffect, useRef } from "react";
// javascipt plugin for creating charts
import Chart from "chart.js";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  NavItem,
  NavLink,
  Nav,
  Col,
  Badge,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Table,
  Container,
  Row,
  UncontrolledTooltip,
  Dropdown,
  CardTitle,
} from "reactstrap";

// core components
import {
  chartOptions,
  parseOptions,
  chartExample1,
  chartExample2,
} from "dashboard/project-management/variables/charts.js";
import {api} from '../../../../api'
import Cookies from 'js-cookie';

const Index = (props) => {
  const [activeNav, setActiveNav] = useState(1);
  const [chartExample1Data, setChartExample1Data] = useState("data1");
  const [selectedOption, setSelectedOption] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);


  const toggleDropdown = () => setDropdownOpen(prevState => !prevState);



  if (window.Chart) {
    parseOptions(Chart, chartOptions());
  }

  const toggleNavs = (e, index) => {
    e.preventDefault();
    setActiveNav(index);
    setChartExample1Data("data" + index);
  };

  const handleOptionSelectChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  const emp_id = Cookies.get('token');
  // let emp_id = 1;


  const [project, setproject] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const response = await api.get(`viewProjectDetails.php?p_m_id=${emp_id}&company_id=${company_id}`);
        setproject(response.data);
        console.log(response.data);
        const response2 = await api.get(`materailsCountdeatils.php?p_id=all&&p_m_id=${emp_id}&company_id=${company_id}`);
        console.log('API Response:', response2.data);
        setbudget(response2.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  console.log(project)


  const [display, setdisplay] = useState("display");
  const [display2, setdisplay2] = useState("none");
  const [budget, setbudget] = useState({ details: [] });
  const handleProjectSelection = async (p_id, p_name = "All Projects") => {
  setSelectedOption(p_name); // <-- add this line
  setdisplay2("display");
  try {
    if (p_id == "all") {
      setdisplay("display");
      const company_id = Cookies.get('company_id');
      const response = await api.get(`materailsCountdeatils.php?p_id=${p_id}&&p_m_id=${emp_id}&company_id=${company_id}`);
      setbudget(response.data);
    } else {
      setdisplay("none");
      const company_id = Cookies.get('company_id');
      const response = await api.get(`materailsCountdeatils.php?p_id=${p_id}&company_id=${company_id}`);
      setbudget(response.data);
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};
  console.log(budget);


  return (
    <>

      <div className="header bg-gradient-info py-7 py-lg-5 ">
      <div className="bg-gradient-info pb-8 pt-2 pt-md-8">
        <Container fluid>
          <div className="header-body">
          <div className="justify-content-end ">
          <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} className="mb-4 justify-content-end " >
            <DropdownToggle caret>
              {selectedOption ? selectedOption : "Select Project"}
            </DropdownToggle>
            <DropdownMenu left>
            {display2 != "none" && (
                <DropdownItem onClick={() => handleProjectSelection("all","all projects")}>
                    All Projects
                </DropdownItem>
            )}
            {Array.isArray(project) ? (
                project.map(project => (
                    <DropdownItem key={project.p_id} onClick={() => handleProjectSelection(project.p_id, project.p_name)}>
                        {project.p_name}
                    </DropdownItem>
                ))
            ) : (
                // Render fallback UI or handle the error in any other appropriate way
                <p className="text-center">No projects found</p>
            )}
            

                  
            </DropdownMenu>
          </Dropdown>
          <span>Select project to view budget details</span>
          </div>
            {/* Card stats */}
            <Row>
  {/* Total Budget */}
  <Col lg="6" xl="4">
    <Card className="card-stats mb-4 mb-xl-3" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',backgroundColor: '#fff'}}>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center">
          <CardTitle tag="h5" className="mb-0">Total Budget</CardTitle>
          <span className="h2 font-weight-bold mb-0">{budget.p_budget}</span>
        </div>
      </CardBody>
    </Card>
  </Col>

  {/* Drained Amount */}
  <Col lg="6" xl="4">
    <Card className="card-stats mb-4 mb-xl-0" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',backgroundColor: '#fff'}}>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center">
          <CardTitle tag="h5" className="mb-0">Drained Amount</CardTitle>
          <span className="h2 font-weight-bold mb-0">{budget.spent}</span>
        </div>
      </CardBody>
    </Card>
  </Col>

  {/* Remaining Amount */}
  <Col lg="6" xl="4">
    <Card className="card-stats mb-4 mb-xl-0" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',backgroundColor: '#fff'}}>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center">
          <CardTitle tag="h5" className="mb-0">Remaining Amount</CardTitle>
          <span className="h2 font-weight-bold mb-0">{budget.remaining}</span>
        </div>
      </CardBody>
    </Card>
  </Col>
</Row>
          </div>
        </Container>
      </div> 
        {/* Page content */}
        <Container className="mt--7 " fluid>
        <Row className="mt-2">
            <Col className="mb-5 " xl="12">
            <Card className="" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px'}}>
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0">Material Details</h3>
                  </div>
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Material Name</th>
                    <th scope="col">Amount Spent</th>
                    <th scope="col">Quantity</th>
                  </tr>
                </thead>
                <tbody>
                {budget.details ? (
                    budget.details.map((material, index) => (
                        <tr key={index}>
                            <td>{material.mat_name}</td>
                            <td>{material.mat_money}</td>
                            <td>{material.mat_quantity}</td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td center colSpan="3">No details available, Project not yet started</td>
                    </tr>
                )}


                </tbody>
              </Table>
            </Card>
          </Col>
          </Row>

          

          
        </Container>
      </div>
    </>
  );
};

export default Index;
